(function () {
  'use strict';

  // 标题 hover 扫光：设计稿 home.js 给页面所有 h1/h2/h3 挂 sticky-gradient-title，
  // mouseenter 加 gradient-locked 触发。这里只作用于 comu 区块的标题，
  // 并沿用设计稿的排除项（KOL 卡 / 评价卡 / 商品卡内的标题不参与）。
  function initGradientTitles(scope) {
    var root = scope || document;
    var nodes = root.querySelectorAll(
      '.comu-section h1, .comu-section h2, .comu-hero .hero-title'
    );
    Array.prototype.forEach.call(nodes, function (el) {
      if (el.dataset.comuGradientReady === 'true') return;
      if (el.closest('.comu-kol-card') || el.closest('.comu-review-card') ||
          el.closest('.product-entry-grid') || el.closest('.bento-card')) return;
      // hero 关掉「标题渐变扫光」后不挂这个类——渐变靠 background-clip: text +
      // 透明字色实现，字色由渐变里的 currentColor 段决定，逐张 Banner 配的纯色
      // 虽然仍生效，但运营会以为「配了色没反应」。关掉即所见即所得。
      if (el.closest('.comu-hero--no-grad')) return;
      el.dataset.comuGradientReady = 'true';
      el.classList.add('comu-gradient-title');
      el.addEventListener('mouseenter', function () { el.classList.add('is-swept'); });
      el.addEventListener('mouseleave', function () { el.classList.remove('is-swept'); });
      // 键盘用户也能触发（标题本身不可聚焦，聚焦到它内部链接时也算）
      el.addEventListener('focusin', function () { el.classList.add('is-swept'); });
      el.addEventListener('focusout', function () { el.classList.remove('is-swept'); });
    });
  }

  // 横滑轨道的无限循环：Impact 的 prev/next-button 到头会把自己 disabled，
  // 这里拦截点击自己算位移，到头绕回另一端，并持续清掉 disabled 属性。
  function initLoopCarousel(track) {
    if (!track || track.dataset.comuLoopReady === 'true') return;
    track.dataset.comuLoopReady = 'true';

    var root = track.closest('.comu-section') || document;
    var prev = root.querySelector('[is="prev-button"]');
    var next = root.querySelector('[is="next-button"]');
    if (!prev && !next) return;

    function step() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function maxScroll() {
      return track.scrollWidth - track.clientWidth;
    }

    function go(dir) {
      var max = maxScroll();
      var at = track.scrollLeft;
      var target = at + dir * step();
      // 到头绕回：容差 2px，避免亚像素卡在末端
      if (dir > 0 && at >= max - 2) target = 0;
      else if (dir < 0 && at <= 2) target = max;
      track.scrollTo({ left: Math.max(0, Math.min(target, max)), behavior: 'smooth' });
    }

    function bind(btn, dir) {
      if (!btn) return;
      // 捕获阶段拦下，抢在 Impact 自己的处理之前
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        // 必须用 stopImmediatePropagation：stopPropagation 只挡冒泡到祖先，
        // 挡不住 Impact 注册在同一个按钮上的处理器，两边会同时滚动互相打架。
        e.stopImmediatePropagation();
        go(dir);
      }, true);
    }
    bind(prev, -1);
    bind(next, 1);

    // Impact 会在滚动时按边界重新置灰，循环模式下按钮必须始终可用
    function undisable() {
      if (prev) prev.removeAttribute('disabled');
      if (next) next.removeAttribute('disabled');
    }
    undisable();
    track.addEventListener('scroll', undisable, { passive: true });
    new MutationObserver(undisable).observe(root, {
      subtree: true, attributes: true, attributeFilter: ['disabled']
    });
  }

  // 左下角悬浮订阅按钮 + 弹窗。表单提交交给 comu-subscribe.js（根元素挂了
  // data-comu-subscribe-module），这里只负责开关、焦点管理与无障碍属性。
  function initFloatingSubscribe(root) {
    if (!root || root.dataset.fsubReady === 'true') return;
    root.dataset.fsubReady = 'true';

    var btn = root.querySelector('[data-comu-fsub-open]');
    var overlay = root.querySelector('[data-comu-fsub-overlay]');
    var panel = root.querySelector('[data-comu-fsub-panel]');
    if (!btn || !overlay || !panel) return;

    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      overlay.hidden = false;
      // 先取消 hidden 再下一帧加 class，否则 opacity 过渡不会触发
      requestAnimationFrame(function () {
        overlay.classList.add('is-visible');
      });
      btn.setAttribute('aria-expanded', 'true');
      var first = panel.querySelector('input[type="email"]') || panel.querySelector('button');
      if (first) first.focus({ preventScroll: true });
      document.addEventListener('keydown', onKey);
    }

    function close() {
      overlay.classList.remove('is-visible');
      btn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKey);
      // 等过渡结束再 hidden，否则会直接跳没
      window.setTimeout(function () {
        if (!overlay.classList.contains('is-visible')) overlay.hidden = true;
      }, 300);
      if (lastFocused && lastFocused.focus) lastFocused.focus({ preventScroll: true });
    }

    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      // 焦点陷阱：弹窗打开时 Tab 不应跑到背后的页面上
      var f = panel.querySelectorAll('a[href], button:not([disabled]), input, select, textarea');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    btn.addEventListener('click', open);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-comu-fsub-close]'), function (el) {
      el.addEventListener('click', close);
    });
  }

  // KOL 卡自动补齐：用 YouTube 公开 oEmbed 拿频道名与视频封面，无需 API key。
  // 注意 oEmbed 不提供「频道头像」，头像仍需运营上传——这是接口本身的限制。
  function initKolAutoFetch(card) {
    if (!card || card.dataset.kolFetchReady === 'true') return;
    var id = card.dataset.comuKolAutofetch;
    if (!id) return;
    card.dataset.kolFetchReady = 'true';

    var needName = card.dataset.kolNeedName === '1';
    var needCover = card.dataset.kolNeedCover === '1';
    var needTitle = card.dataset.kolNeedTitle === '1';
    if (!needName && !needCover && !needTitle) return;

    var url = 'https://www.youtube.com/oembed?format=json&url=' +
      encodeURIComponent('https://www.youtube.com/watch?v=' + id);

    fetch(url, { mode: 'cors' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d) return;
        if (needName && d.author_name) {
          // 沉浸卡与缩略卡的频道名用不同类名，一起查
          var nameEl = card.querySelector('.comu-kol-card__channel-name, .comu-kol-card__name');
          // 直接覆盖：手填值只是脚本返回前的占位，抓到就以抓到的为准
          if (nameEl) nameEl.textContent = d.author_name;
        }
        if (needTitle && d.title) {
          var q = card.querySelector('.comu-kol-card__title, .comu-kol-card__quote');
          if (q) q.textContent = d.title;
        }
        // oEmbed 给的是 hqdefault.jpg——480×360 的 4:3 图，16:9 视频会带上下黑边，
        // 铺进 16:9 缩略卡会糊且有黑边。改成优先取 maxresdefault(1280×720)，
        // 拿不到（老视频/低清上传没有这一档）再依次回落，最后才用 oEmbed 原值。
        var coverList = [
          'https://i.ytimg.com/vi/' + id + '/maxresdefault.jpg',
          'https://i.ytimg.com/vi/' + id + '/sddefault.jpg',
          d.thumbnail_url
        ];
        var applyCover = function (img) {
          var n = 0;
          img.onerror = function () {
            n += 1;
            if (n < coverList.length) img.setAttribute('src', coverList[n]);
            else img.onerror = null;
          };
          img.setAttribute('src', coverList[0]);
        };
        if (needCover && d.thumbnail_url) {
          var img = card.querySelector('.comu-kol-card__image');
          if (img && (!img.getAttribute('src') || img.tagName === 'SVG')) {
            applyCover(img);
          } else if (!img) {
            var holder = card.querySelector('.comu-kol-card__bg, .comu-kol-card__thumb');
            if (holder) {
              var el = document.createElement('img');
              el.className = 'comu-kol-card__image';
              el.loading = 'lazy';
              el.alt = d.author_name || '';
              applyCover(el);
              holder.insertBefore(el, holder.firstChild);
            }
          }
        }
      })
      .catch(function () { /* 取不到就保持运营填的值/占位，不影响其它功能 */ });
  }

  // Hero 多 Banner 轮播：自动切换 + 左右箭头 + 圆点，悬停/聚焦/滚出视口暂停。
  function initHeroCarousel(root) {
    if (!root || root.dataset.heroCarouselReady === 'true') return;
    root.dataset.heroCarouselReady = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-comu-hero-slide]'));
    if (slides.length < 2) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-comu-hero-dot]'));
    var ms = parseInt(root.dataset.comuHeroInterval, 10) || 0;
    var idx = 0;
    var timer = null;
    var offscreen = false;

    function show(next) {
      var prev = idx;
      idx = (next + slides.length) % slides.length;
      slides.forEach(function (el, i) {
        el.classList.toggle('is-active', i === idx);
        // 横向滑动时，刚离开的那张要滑向左侧而不是瞬移到右侧
        el.classList.toggle('is-prev', i === prev && i !== idx);
        if (i === idx) el.removeAttribute('aria-hidden');
        else el.setAttribute('aria-hidden', 'true');
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
        d.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });
    }

    function start() {
      if (timer || !ms || offscreen) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = window.setInterval(function () { show(idx + 1); }, ms);
    }
    function stop() { window.clearInterval(timer); timer = null; }
    function restart() { stop(); start(); }

    var prevBtn = root.querySelector('[data-comu-hero-prev]');
    var nextBtn = root.querySelector('[data-comu-hero-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { show(idx - 1); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(idx + 1); restart(); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { show(i); restart(); });
    });

    root.addEventListener('pointerenter', stop);
    root.addEventListener('pointerleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    if (typeof IntersectionObserver === 'function') {
      new IntersectionObserver(function (entries) {
        offscreen = !entries[0].isIntersecting;
        if (offscreen) stop(); else start();
      }).observe(root);
    }

    show(0);
    start();
  }

  function initCkmModule(root) {
    if (!root || root.dataset.ckmReady === 'true') return;
    root.dataset.ckmReady = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('.ckm-tab'));
    var stage = root.querySelector('[data-ckm-stage]');
    var commandText = root.querySelector('[data-ckm-command-text]');
    if (!tabs.length || !stage) return;

    var activeIndex = 0;
    var timer = null;
    // 属性缺失（老实例没这个设置）→ 用默认 2600ms；填 0 → 关掉自动切换，只能点标签切。
    // 不能写 `|| 2600`：那会把「0 = 关闭」当成没填，又跑回自动切换。
    var raw = parseInt(root.getAttribute('data-ckm-interval'), 10);
    var delay = isNaN(raw) ? 2600 : raw;

    function renderStage(images) {
      var slide = function (variant) {
        var src = images[variant] || images.main;
        if (!src) return '';
        return '<article class="ckm-slide ckm-slide-' + variant + '">' +
          '<img src="' + src + '" alt="" loading="lazy">' +
          '</article>';
      };
      stage.innerHTML = slide('left') + slide('main') + slide('right');
    }

    function setMode(index) {
      index = (index + tabs.length) % tabs.length;
      activeIndex = index;

      var tab = tabs[index];
      var mainImg = tab.getAttribute('data-ckm-main') || tab.getAttribute('data-ckm-image');
      var images = {
        main: mainImg,
        left: tab.getAttribute('data-ckm-left') || mainImg,
        right: tab.getAttribute('data-ckm-right') || mainImg
      };
      var command = tab.getAttribute('data-ckm-command');

      if (commandText && command) commandText.textContent = command;
      if (images.main) renderStage(images);

      tabs.forEach(function (item, i) {
        var isActive = i === index;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function restartTimer() {
      window.clearInterval(timer);
      if (delay <= 0) return;
      timer = window.setInterval(function () {
        setMode(activeIndex + 1);
      }, delay);
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        setMode(i);
        restartTimer();
      });
    });

    setMode(0);
    restartTimer();
  }

  function initScenarioModule(root) {
    if (!root || root.dataset.scnReady === 'true') return;
    root.dataset.scnReady = 'true';

    var photos = Array.prototype.slice.call(root.querySelectorAll('.scenario-photo'));
    if (!photos.length) return;

    function setActive(target) {
      photos.forEach(function (photo) {
        photo.classList.toggle('active', photo === target);
      });
    }

    photos.forEach(function (photo) {
      photo.addEventListener('mouseenter', function () { setActive(photo); });
      photo.addEventListener('click', function (event) {
        event.preventDefault();
        setActive(photo);
      });
    });

    setActive(photos[0]);
  }

  function initComplianceCarousel(root) {
    if (!root || root.dataset.cmpReady === 'true') return;
    root.dataset.cmpReady = 'true';

    var viewport = root.querySelector('.compliance-carousel__viewport');
    var prev = root.querySelector('[data-cp-prev]');
    var next = root.querySelector('[data-cp-next]');
    if (!viewport) return;

    function step(dir) {
      var card = viewport.querySelector('.compliance-card');
      var unit = card ? card.getBoundingClientRect().width + 24 : viewport.clientWidth * 0.8;
      viewport.scrollBy({ left: dir * unit, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  }

  function initTimelineModule(root) {
    if (!root || root.dataset.tlReady === 'true') return;
    root.dataset.tlReady = 'true';

    var rows = Array.prototype.slice.call(root.querySelectorAll('.timeline-row'));
    if (!rows.length) return;

    var hasActive = rows.some(function (r) { return r.classList.contains('active'); });
    if (!hasActive) rows[0].classList.add('active');

    function setActive(target) {
      rows.forEach(function (row) { row.classList.toggle('active', row === target); });
    }

    rows.forEach(function (row) {
      row.addEventListener('pointerenter', function () { setActive(row); });
      row.addEventListener('click', function () { setActive(row); });
    });
  }

  function initAudienceModule(root) {
    if (!root || root.dataset.audReady === 'true') return;
    root.dataset.audReady = 'true';

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-audience-item]'));
    var image = root.querySelector('[data-audience-image]');
    var imagePrev = root.querySelector('[data-audience-image-prev]');
    var imageNext = root.querySelector('[data-audience-image-next]');
    var list = root.querySelector('.audience-list');
    if (!items.length || !image) return;

    var delay = parseInt(root.style.getPropertyValue('--audience-delay'), 10) || 5400;
    var timer = null;
    var activeIndex = 0;
    var suppressScrollSync = false;
    var hasInitialized = false;
    var mobileQuery = window.matchMedia('(max-width: 768px)');

    function isMobileLayout() {
      return mobileQuery.matches;
    }

    function scrollActiveItemIntoView(item) {
      if (!list || !item) return;

      if (isMobileLayout()) {
        suppressScrollSync = true;
        var listRect = list.getBoundingClientRect();
        var itemRect = item.getBoundingClientRect();
        var itemLeft = itemRect.left - listRect.left + list.scrollLeft;
        var targetLeft = itemLeft - (list.clientWidth - itemRect.width) / 2;
        list.scrollTo({
          left: Math.max(0, targetLeft),
          behavior: hasInitialized ? 'smooth' : 'auto'
        });
        window.setTimeout(function () { suppressScrollSync = false; }, 400);
        return;
      }

      var itemRect = item.getBoundingClientRect();
      var listRect = list.getBoundingClientRect();
      var elemTop = itemRect.top - listRect.top + list.scrollTop;
      if (elemTop < list.scrollTop) {
        list.scrollTo({ top: elemTop - 20, behavior: 'smooth' });
      } else if (elemTop + itemRect.height > list.scrollTop + list.clientHeight) {
        list.scrollTo({ top: elemTop + itemRect.height - list.clientHeight + 20, behavior: 'smooth' });
      }
    }

    function getCenteredItemIndex() {
      if (!list || !items.length) return activeIndex;

      var listRect = list.getBoundingClientRect();
      var centerX = listRect.left + listRect.width / 2;
      var closestIndex = activeIndex;
      var closestDistance = Infinity;

      items.forEach(function (it, index) {
        var rect = it.getBoundingClientRect();
        var itemCenter = rect.left + rect.width / 2;
        var distance = Math.abs(itemCenter - centerX);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function setSlide(nextIndex) {
      var len = items.length;
      var idx = (nextIndex + len) % len;
      var item = items[idx];
      var src = item.getAttribute('data-image');
      var alt = item.getAttribute('data-alt') || '';
      var prevSrc = items[(idx - 1 + len) % len].getAttribute('data-image');
      var nextSrc = items[(idx + 1) % len].getAttribute('data-image');
      activeIndex = idx;
      window.clearTimeout(timer);

      items.forEach(function (it) {
        it.classList.remove('active');
        it.setAttribute('aria-selected', 'false');
      });

      var changed = src && image.getAttribute('src') !== src;
      function updateImages() {
        if (src) { image.setAttribute('src', src); image.setAttribute('alt', alt); }
        if (imagePrev && prevSrc) imagePrev.setAttribute('src', prevSrc);
        if (imageNext && nextSrc) imageNext.setAttribute('src', nextSrc);
      }

      if (changed) {
        image.classList.add('is-changing');
        if (imagePrev) imagePrev.classList.add('is-changing');
        if (imageNext) imageNext.classList.add('is-changing');
        window.setTimeout(function () {
          updateImages();
          window.requestAnimationFrame(function () {
            image.classList.remove('is-changing');
            if (imagePrev) imagePrev.classList.remove('is-changing');
            if (imageNext) imageNext.classList.remove('is-changing');
          });
        }, 170);
      } else {
        updateImages();
      }

      window.requestAnimationFrame(function () {
        item.classList.add('active');
        item.setAttribute('aria-selected', 'true');
        if (hasInitialized) {
          scrollActiveItemIntoView(item);
        }
        hasInitialized = true;
      });

      timer = window.setTimeout(function () { setSlide(activeIndex + 1); }, delay);
    }

    items.forEach(function (item, index) {
      item.addEventListener('click', function () { setSlide(index); });
    });

    if (list) {
      var scrollTimer = null;
      list.addEventListener('scroll', function () {
        if (!isMobileLayout() || suppressScrollSync) return;
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          var centeredIndex = getCenteredItemIndex();
          if (centeredIndex !== activeIndex) {
            setSlide(centeredIndex);
          }
        }, 120);
      }, { passive: true });
    }

    setSlide(0);
  }

  // 媒体引语跟随跑马灯：引语切换为最靠近视口水平中心的 Logo，点击可钉住
  function initMediaQuoteModule(root) {
    if (root.dataset.comuMediaBound === '1') return;
    var quoteText = root.querySelector('[data-comu-quote-text]');
    var items = Array.prototype.slice.call(root.querySelectorAll('.media-logo-item[data-comu-quote]'));
    if (!quoteText || items.length === 0) return;
    root.dataset.comuMediaBound = '1';

    var PIN_MS = 4000;
    var FADE_MS = 200;
    var isPinned = false;
    var pinTimer = null;
    var currentQuote = null;
    var rafId = null;

    function showQuote(quote) {
      if (!quote || currentQuote === quote) return;
      currentQuote = quote;
      quoteText.style.opacity = '0';
      setTimeout(function () {
        quoteText.textContent = quote;
        quoteText.style.opacity = '1';
      }, FADE_MS);
    }

    function pickNearest() {
      var center = window.innerWidth / 2;
      var best = null;
      var bestDistance = Infinity;
      for (var i = 0; i < items.length; i++) {
        var rect = items[i].getBoundingClientRect();
        if (rect.right <= 0 || rect.left >= window.innerWidth) continue;
        var distance = Math.abs(center - (rect.left + rect.width / 2));
        if (distance < bestDistance) {
          bestDistance = distance;
          best = items[i];
        }
      }
      return best;
    }

    function tick() {
      if (!isPinned) {
        var nearest = pickNearest();
        if (nearest) showQuote(nearest.dataset.comuQuote);
      }
      rafId = requestAnimationFrame(tick);
    }

    function start() {
      if (rafId === null) rafId = requestAnimationFrame(tick);
    }

    function stop() {
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
    }

    function pin(item) {
      showQuote(item.dataset.comuQuote);
      isPinned = true;
      clearTimeout(pinTimer);
      pinTimer = setTimeout(function () { isPinned = false; }, PIN_MS);
    }

    items.forEach(function (item) {
      item.addEventListener('click', function () { pin(item); });
      // 只让未被 aria-hidden 的那一组进入 Tab 序列，避免重复副本污染键盘导航
      if (!item.closest('[aria-hidden="true"]')) {
        item.setAttribute('tabindex', '0');
        item.setAttribute('role', 'button');
        item.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            pin(item);
          }
        });
      }
    });

    if (typeof IntersectionObserver === 'function') {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { start(); } else { stop(); }
      }, { threshold: 0 }).observe(root);
    } else {
      start();
    }
  }

  function initVideoTabsModule(root) {
    if (!root || root.dataset.videoTabsReady === 'true') return;
    root.dataset.videoTabsReady = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('.comu-video-tabs__tab'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.comu-video-tabs__panel'));
    if (tabs.length < 2 || panels.length !== tabs.length) return;

    // 横滑档下，被激活的标签可能在可视区之外，把它滑进视野。
    //
    // ⚠️ 绝不能用 scrollIntoView：它会滚动**所有可滚动祖先**，包括页面本身。
    //    自动轮播每隔几秒调一次 activate()，用户滚到别处时会被硬拽回本模块
    //    （实测手机档从 y=4540 被拽回 4152）。这里只改导航条自己的 scrollLeft，
    //    页面滚动位置一动不动。
    function revealTab(tab) {
      if (!tab || !root.classList.contains('comu-video-tabs--ovf-scroll')) return;
      var nav = tab.parentElement;
      if (!nav || nav.scrollWidth <= nav.clientWidth + 1) return;

      var pad = 12;
      var left = nav.scrollLeft;
      var visibleRight = left + nav.clientWidth;
      var target = left;

      if (tab.offsetLeft < left) {
        target = tab.offsetLeft - pad;
      } else if (tab.offsetLeft + tab.offsetWidth > visibleRight) {
        target = tab.offsetLeft + tab.offsetWidth - nav.clientWidth + pad;
      }
      if (target === left) return;

      target = Math.max(0, Math.min(target, nav.scrollWidth - nav.clientWidth));
      if (typeof nav.scrollTo === 'function') {
        nav.scrollTo({ left: target, behavior: 'smooth' });
      } else {
        nav.scrollLeft = target;
      }
    }

    function activate(index) {
      activeIndex = index;
      revealTab(tabs[index]);
      tabs.forEach(function (tab, i) {
        var isActive = i === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach(function (panel, i) {
        var isActive = i === index;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;

        // 切走的面板要暂停播放，避免多个视频同时出声
        if (!isActive) {
          var video = panel.querySelector('video');
          if (video && !video.paused) video.pause();
          return;
        }

        // 面板平时是 display:none，原生 loading="lazy" 在隐藏容器里判定不可靠——
        // 实测最后一个面板的底图即使已经进了视口、等 8 秒也不发请求。
        // 面板一旦激活就把它的图改成 eager，让浏览器立刻取，首屏字节数不受影响。
        panel.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
          img.loading = 'eager';
          // 少数情况下改 loading 不会重新触发取图，补一次同值 src 赋值把它踢起来
          if (!img.complete && img.getAttribute('src')) img.src = img.getAttribute('src');
        });

        // 「图片 + 嵌入视频」模式：激活的面板从头自动播放（静音，无控件）。
        // 只对 .comu-video-tabs__inset 里的视频生效——标准模式的视频带播放按钮，
        // 由用户主动触发，不能替他自动播。
        var inset = panel.querySelector('.comu-video-tabs__inset video');
        if (!inset) {
          /* 标准模式：默认不替用户自动播（视频带播放按钮，应由他主动触发）。
             开启「自动播放」后才播——设计稿 #precision-engineering 就是
             进 Tab 自动播、播完推进下一个 Tab、取模循环回第一个。 */
          if (!videoAutoplay) return;
          var host = panel.querySelector('video-media');
          var main = host ? host.querySelector('video') : null;
          if (!main) return;
          /* 未静音的自动播放会被浏览器拦截，必须先静音 */
          main.muted = true;
          /* video-media 靠 loaded 属性把视频显示到封面之上，不加就只看得见封面 */
          host.setAttribute('loaded', '');
          main.loop = !advanceOnEnd;
          if (advanceOnEnd && !main.dataset.comuEndBound) {
            main.dataset.comuEndBound = '1';
            main.addEventListener('ended', function () {
              if (panel.classList.contains('is-active')) activate((index + 1) % tabs.length);
            });
          }
          try {
            main.currentTime = 0;
          } catch (e) {
            /* 元数据未就绪时设 currentTime 会抛错，忽略 */
          }
          if (!inView) return;
          var pm = main.play();
          if (pm && pm.catch) pm.catch(function () {});
          return;
        }
        inset.muted = true;
        // 设计稿的行为是「播完一遍推进下一个 Tab」，不是循环；
        // 关掉推进时才让它循环，否则播完就静止在最后一帧。
        inset.loop = !advanceOnEnd;
        if (advanceOnEnd && !inset.dataset.comuEndBound) {
          inset.dataset.comuEndBound = '1';
          inset.addEventListener('ended', function () {
            if (panel.classList.contains('is-active')) activate((index + 1) % tabs.length);
          });
        }
        try {
          inset.currentTime = 0;
        } catch (e) {
          /* 元数据未就绪时设 currentTime 会抛错，忽略即可 */
        }
        var p = inset.play();
        if (p && p.catch) p.catch(function () {});
      });
    }

    // 自动轮播（设计稿 #app 用，间隔由 data-comu-tabs-autoplay 传入，0 = 关闭）
    // advance_on_end 与定时轮播互斥：由视频的 ended 事件驱动推进，定时器会打断播放
    var advanceOnEnd = root.dataset.comuTabsAdvanceOnEnd === 'true';
    var videoAutoplay = root.dataset.comuTabsVideoAutoplay === 'true';
    /* 自动播放档：模块不在视口里就不起播。
       activate(0) 在 DOMContentLoaded 就跑，而本模块通常在首屏之下——
       不拦的话页面一加载就开始下载视频，白白吃掉流量。
       初值 false，由下面的 IntersectionObserver 在 observe() 后立刻回调纠正。 */
    var inView = !videoAutoplay;
    var rotateMs = advanceOnEnd ? 0 : parseInt(root.dataset.comuTabsAutoplay, 10) || 0;
    var rotateTimer = null;
    var activeIndex = 0;

    function stopRotate() {
      window.clearInterval(rotateTimer);
      rotateTimer = null;
    }

    function startRotate() {
      if (!rotateMs || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      stopRotate();
      rotateTimer = window.setInterval(function () {
        activate((activeIndex + 1) % tabs.length);
      }, rotateMs);
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activate(i);
        startRotate(); // 手动切换后重新计时，避免刚点完就被自动切走
      });

      tab.addEventListener('keydown', function (event) {
        var offset = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
        if (!offset) return;
        event.preventDefault();
        var next = (i + offset + tabs.length) % tabs.length;
        activate(next);
        tabs[next].focus();
        startRotate();
      });
    });

    activate(0);
    startRotate();

    // 悬停/聚焦时暂停轮播，滚出视口也停，避免后台空转
    root.addEventListener('pointerenter', stopRotate);
    root.addEventListener('pointerleave', startRotate);
    root.addEventListener('focusin', stopRotate);
    root.addEventListener('focusout', startRotate);

    if (rotateMs && typeof IntersectionObserver === 'function') {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) startRotate();
        else stopRotate();
      }).observe(root);
    }

    /* 自动播放档：滚出视口就暂停，滚回来续播。
       设计稿同样的做法（threshold 0.3），既省流量也避免后台空转。
       单独一个观察器，不动上面那条轮播用的，免得改到既有实例的行为。 */
    if (videoAutoplay && typeof IntersectionObserver === 'function') {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        var panel = panels[activeIndex];
        var v = panel ? panel.querySelector('video') : null;
        if (!v) return;
        if (inView) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      }, { threshold: 0.3 }).observe(root);
    }
  }

  // 视频右上角的播放/暂停按钮。video-media 默认延迟加载，视频要等 loaded
  // 属性出现才可见（主题 CSS 控制），所以首次播放时要一并补上。
  function initVideoPlayButton(button) {
    if (button.dataset.videoToggleReady === 'true') return;
    button.dataset.videoToggleReady = 'true';

    var host = button.parentElement;
    var video = host.querySelector('video');
    if (!video) {
      button.remove();
      return;
    }

    function sync() {
      var playing = !video.paused && !video.ended;
      button.dataset.playing = playing ? 'true' : 'false';
      button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
    }

    button.addEventListener('click', function (event) {
      // video-media 自身也响应点击，否则会与这里的切换互相抵消
      event.stopPropagation();

      if (video.paused) {
        host.setAttribute('loaded', '');
        var started = video.play();
        if (started && typeof started.catch === 'function') started.catch(function () {});
      } else {
        video.pause();
      }
    });

    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    video.addEventListener('ended', sync);
    sync();
  }

  // 横向轨道自动滚动：匀速右移，滚到末尾回到开头。
  // 悬停 / 键盘聚焦 / 用户自己滚动或拖动时暂停，滚出视口也停（避免后台空转）。
  function initTrackAutoscroll(root, track) {
    var speed = parseFloat(root.dataset.comuReviewAutoscroll || '0');
    if (!track || !speed || speed <= 0) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // ⚠️ 轨道带 scroll-snap-type: x mandatory 时，逐像素设 scrollLeft 会被立刻吸附回
    // 最近的吸附点（起点就是 0），表现为「完全不动」。自动滚动期间必须关掉吸附。
    track.style.scrollSnapType = 'none';

    var paused = false;
    var offscreen = false;
    var userPauseTimer = null;
    var last = null;
    var rafId = null;
    // scrollLeft 是整数，逐帧加不满 1px 会被抹平，所以自己累计小数
    var acc = 0;

    function step(now) {
      if (last === null) last = now;
      var dt = (now - last) / 1000;
      last = now;
      if (!paused && !offscreen) {
        var max = track.scrollWidth - track.clientWidth;
        if (max > 1) {
          acc += speed * dt;
          var whole = Math.floor(acc);
          if (whole > 0) {
            acc -= whole;
            // 到末尾直接跳回开头；用 auto 而非 smooth，否则会和 rAF 打架
            track.scrollLeft = track.scrollLeft + whole >= max ? 0 : track.scrollLeft + whole;
          }
        }
      }
      rafId = requestAnimationFrame(step);
    }

    function pause() { paused = true; }
    function resume() { paused = false; last = null; }

    root.addEventListener('pointerenter', pause);
    root.addEventListener('pointerleave', resume);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', resume);
    // 用户自己滚/拖之后先让开 2 秒，别跟人抢
    ['wheel', 'touchstart', 'pointerdown'].forEach(function (evt) {
      track.addEventListener(evt, function () {
        paused = true;
        window.clearTimeout(userPauseTimer);
        userPauseTimer = window.setTimeout(resume, 2000);
      }, { passive: true });
    });

    if (typeof IntersectionObserver === 'function') {
      new IntersectionObserver(function (entries) {
        offscreen = !entries[0].isIntersecting;
        if (!offscreen) last = null;
      }).observe(root);
    }

    rafId = requestAnimationFrame(step);
  }

  function initReviewCardsModule(root) {
    if (!root || root.dataset.reviewCardsReady === 'true') return;
    root.dataset.reviewCardsReady = 'true';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-comu-review-open]'));
    if (!cards.length) return;

    initTrackAutoscroll(root, root.querySelector('.comu-review-cards__track'));

    // 文案由 section 设置注入，JS 里只留兜底
    var labels = {
      more: root.dataset.moreLabel || 'More',
      less: root.dataset.lessLabel || 'Less',
      close: root.dataset.closeLabel || 'Close'
    };

    // 整个区块共用一个 dialog，内容按需从卡片的 template 里取
    var dialog = document.createElement('dialog');
    dialog.className = 'comu-review-modal';
    dialog.innerHTML =
      '<button type="button" class="comu-review-modal__close">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>' +
      '</button><div class="comu-review-modal__content"></div>';
    root.appendChild(dialog);

    var content = dialog.querySelector('.comu-review-modal__content');
    var closeBtn = dialog.querySelector('.comu-review-modal__close');
    if (closeBtn) closeBtn.setAttribute('aria-label', labels.close);

    // 正文超过折叠高度时才显示 More，展开用具体像素值以便过渡动画生效
    function setupExpander() {
      var text = content.querySelector('[data-comu-review-text]');
      var more = content.querySelector('[data-comu-review-more]');
      if (!text || !more) return;

      var collapsed = 140;
      if (text.scrollHeight <= collapsed + 8) return;

      var label = more.querySelector('[data-comu-review-more-label]');
      more.hidden = false;
      more.addEventListener('click', function () {
        var expanded = more.classList.toggle('is-expanded');
        text.classList.toggle('is-expanded', expanded);
        text.style.maxHeight = expanded ? text.scrollHeight + 'px' : collapsed + 'px';
        if (label) label.textContent = expanded ? labels.less : labels.more;
      });
    }

    // 弹窗内多图缩略图切换主图
    function setupThumbs() {
      var thumbs = content.querySelectorAll('[data-comu-review-thumb]');
      if (thumbs.length < 2) return;
      var main = content.querySelector('.comu-review-modal__figure img');
      if (!main) return;

      Array.prototype.forEach.call(thumbs, function (thumb) {
        thumb.addEventListener('click', function () {
          main.src = thumb.dataset.src;
          main.removeAttribute('srcset');
          Array.prototype.forEach.call(thumbs, function (other) {
            other.classList.toggle('is-active', other === thumb);
          });
        });
      });
    }

    function open(card) {
      var tpl = card.querySelector('[data-comu-review-content]');
      if (!tpl) return;
      content.innerHTML = '';
      content.appendChild(tpl.content.cloneNode(true));
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      setupExpander();
      setupThumbs();
    }

    function close() {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        open(card);
      });
      card.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        open(card);
      });
    });

    dialog.querySelector('.comu-review-modal__close').addEventListener('click', close);

    // 点击遮罩层（dialog 自身区域，而非内容区）关闭
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) close();
    });
  }

  function initKolCardsModule(root) {
    if (!root || root.dataset.kolCardsReady === 'true') return;
    root.dataset.kolCardsReady = 'true';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-comu-kol-open]'));
    if (!cards.length) return;

    var dialog = document.createElement('dialog');
    dialog.className = 'comu-kol-modal';
    dialog.innerHTML =
      '<div class="comu-kol-modal__content">' +
      '<button type="button" class="comu-kol-modal__close" aria-label="Close">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>' +
      '</button><div class="comu-kol-modal__media"></div></div>';
    root.appendChild(dialog);

    var media = dialog.querySelector('.comu-kol-modal__media');
    var content = dialog.querySelector('.comu-kol-modal__content');

    // 弹窗原本写死 9/16，是按 YouTube Shorts 设计的。放横屏视频会被
    // object-fit: cover 裁掉两边，看不全。这里在打开时判定朝向，套对应的比例：
    //   1. 运营在 block 里显式选了朝向 → 用它
    //   2. YouTube 链接含 /shorts/ → 竖屏；其余 YouTube 链接 → 横屏
    //   3. 本站上传的视频 → 先按默认展示，元数据到手后用真实宽高纠正
    function ratioFromSource(card) {
      var explicit = card.getAttribute('data-comu-kol-orientation');
      if (explicit === 'portrait') return '9 / 16';
      if (explicit === 'landscape') return '16 / 9';

      /* 判断只能看原始链接：iframe 里统一是 /embed/ID，Shorts 标记已经被抹掉 */
      var src = card.getAttribute('data-comu-kol-src') || '';
      if (/\/shorts\//.test(src)) return '9 / 16';
      if (/youtube\.com|youtu\.be|vimeo\.com/.test(src)) return '16 / 9';

      var tpl = card.querySelector('[data-comu-kol-video]');
      var html = tpl ? tpl.innerHTML : '';
      if (/youtube\.com|youtu\.be|vimeo\.com/.test(html)) return '16 / 9';
      return null; // 上传的视频：等元数据
    }

    function applyRatio(ratio) {
      if (!ratio) return;
      content.style.aspectRatio = ratio;
      var landscape = ratio === '16 / 9';
      content.classList.toggle('comu-kol-modal__content--landscape', landscape);
    }

    function open(card) {
      var tpl = card.querySelector('[data-comu-kol-video]');
      if (!tpl) return;

      var ratio = ratioFromSource(card);
      /* 拿不准时先按竖屏（历史行为），元数据回来再纠正，避免打开瞬间跳一下 */
      applyRatio(ratio || '9 / 16');

      media.appendChild(tpl.content.cloneNode(true));
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');

      // 自动播放带声音常被浏览器拦截，失败就留给用户点原生控件
      var video = media.querySelector('video');
      if (video && typeof video.play === 'function') {
        if (!ratio) {
          var fix = function () {
            if (!video.videoWidth || !video.videoHeight) return;
            applyRatio(video.videoWidth >= video.videoHeight ? '16 / 9' : '9 / 16');
          };
          video.addEventListener('loadedmetadata', fix);
          fix();
        }
        var played = video.play();
        if (played && typeof played.catch === 'function') played.catch(function () {});
      }
    }

    function close() {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      // 清空而非隐藏：iframe 留在 DOM 里会继续播放并出声
      media.innerHTML = '';
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        open(card);
      });
      card.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        open(card);
      });
    });

    dialog.querySelector('.comu-kol-modal__close').addEventListener('click', close);
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) close();
    });

    // Esc 按原生流程走 cancel -> close，但 close 事件在部分内嵌浏览器里不触发。
    // 这里接管 cancel 自行收尾，close 再兜一层，避免弹窗关掉后视频仍在后台出声。
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      close();
    });
    dialog.addEventListener('close', function () {
      media.innerHTML = '';
    });
  }

  function initImageCarouselModule(root) {
    if (!root || root.dataset.imageCarouselReady === 'true') return;
    root.dataset.imageCarouselReady = 'true';

    var seconds = parseFloat(root.getAttribute('data-autoplay'));
    if (!seconds) return;

    var carousel = root.querySelector('scroll-carousel');
    if (!carousel) return;

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var timer = null;
    var hovered = false;

    // scroll-carousel 自身不带自动播放，但 BaseCarousel 会响应 control:* 事件，
    // 这里只负责按节奏派发，滚动与圆点同步仍交给主题组件。
    function advance() {
      var total = carousel.items ? carousel.items.length : 0;
      if (total < 2) return;

      if (carousel.selectedIndex >= total - 1) {
        carousel.dispatchEvent(new CustomEvent('control:select', { detail: { index: 0 } }));
      } else {
        carousel.dispatchEvent(new CustomEvent('control:next'));
      }
    }

    function start() {
      stop();
      if (hovered || document.hidden) return;
      timer = window.setInterval(advance, seconds * 1000);
    }

    function stop() {
      window.clearInterval(timer);
      timer = null;
    }

    // 用 pointer 事件，鼠标与触控笔一致；触屏用户滑动时也不会被自动播放打断
    root.addEventListener('pointerenter', function () {
      hovered = true;
      stop();
    });
    root.addEventListener('pointerleave', function () {
      hovered = false;
      start();
    });
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', start);

    start();
  }

  function initQuickNavModule(root) {
    if (!root || root.dataset.quickNavReady === 'true') return;
    root.dataset.quickNavReady = 'true';

    var links = Array.prototype.slice.call(root.querySelectorAll('.comu-quick-nav__link'));
    if (!links.length) return;

    // 目标可以写区块自定义的锚点 ID，也可以写 JSON 模板里的区块键名。
    // 后者渲染出的 DOM id 形如 shopify-section-template--<模板号>__<键名>，模板号不可预知，故按后缀兜底匹配。
    function resolveTarget(id) {
      if (!id) return null;
      return (
        document.getElementById(id) ||
        document.getElementById('shopify-section-' + id) ||
        document.querySelector('[id$="__' + id + '"]')
      );
    }

    var targets = links
      .map(function (link) {
        var section = resolveTarget((link.getAttribute('href') || '').slice(1));
        return section ? { link: link, section: section } : null;
      })
      .filter(Boolean);

    if (!targets.length) return;

    var lastActive = null;

    function setActive(link) {
      // 只在激活项真的变了才滚动：sync() 每个滚动帧都会调进来，
      // 无条件 scrollTo 会把用户正在横滑的导航条每帧拽回去。
      var changed = link !== lastActive;
      lastActive = link;

      links.forEach(function (item) {
        var isActive = item === link;
        item.classList.toggle('is-active', isActive);

        if (!isActive) {
          item.removeAttribute('aria-current');
          return;
        }

        item.setAttribute('aria-current', 'true');
        if (!changed) return;

        // 移动端导航横向溢出时，把当前项滚到可视区中间，否则高亮在屏幕外看不见
        var list = item.closest('.comu-quick-nav__list');
        if (!list || list.scrollWidth <= list.clientWidth) return;

        // 用 rect 而非 offsetLeft：offsetParent 是吸顶的 section 而不是滚动容器
        var listRect = list.getBoundingClientRect();
        var itemRect = item.getBoundingClientRect();
        var itemLeft = itemRect.left - listRect.left + list.scrollLeft;
        var target = Math.max(0, itemLeft - (list.clientWidth - itemRect.width) / 2);

        if (typeof list.scrollTo === 'function') {
          list.scrollTo({ left: target, behavior: 'smooth' });
        } else {
          list.scrollLeft = target;
        }
      });
    }

    var navSection = root.closest('.shopify-section');

    // 吸顶位置来自区块自身的 sticky top，浏览器已把 calc() 解析成 px，
    // 也会随 header 滚动收起（--header-is-visible 变 0）自动更新。未吸顶时为 auto。
    function stickyOffset() {
      return parseFloat(getComputedStyle(navSection).top) || 0;
    }

    // 按吸顶位置算判定线，而不是读导航条的实时位置：
    // 关掉吸顶时导航条会滚出视口，实时位置会变成负值让判定全部失效。
    function activeLine() {
      return stickyOffset() + root.offsetHeight + 32;
    }

    var pinnedUntil = 0;
    var ticking = false;

    function sync() {
      ticking = false;
      if (Date.now() < pinnedUntil) return;

      var line = activeLine();
      var current = null;

      targets.forEach(function (entry) {
        if (entry.section.getBoundingClientRect().top <= line) current = entry.link;
      });

      setActive(current || targets[0].link);
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(sync);
      },
      { passive: true }
    );

    // 锚点跳转时补偿吸顶条高度，避免标题被遮挡
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var section = resolveTarget((link.getAttribute('href') || '').slice(1));
        if (!section) return;

        event.preventDefault();
        var offset = root.offsetHeight + stickyOffset();
        var top = section.getBoundingClientRect().top + window.pageYOffset - offset;

        // 平滑滚动途中会持续触发 scroll，先锁住高亮，避免中间态把选中项冲掉
        setActive(link);
        pinnedUntil = Date.now() + 900;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });

    sync();
  }

  // Bento 权益卡：卡面只显示图标+标题，正文在弹窗里。
  // 弹窗由 JS 动态建 <dialog>（多实例不会 id 冲突，并白拿 Esc 关闭与 focus trap）。
  function initBentoModule(root) {
    if (!root || root.dataset.bentoReady === 'true') return;
    root.dataset.bentoReady = 'true';

    var cards = Array.prototype.slice.call(root.querySelectorAll('.bento-card'));
    if (!cards.length) return;

    var closeLabel = root.dataset.closeLabel || 'Close';

    var dialog = document.createElement('dialog');
    dialog.className = 'comu-bento-modal';
    dialog.innerHTML =
      '<button type="button" class="comu-bento-modal__close">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>' +
      '</button><div class="comu-bento-modal__content"></div>';
    root.appendChild(dialog);

    var closeBtn = dialog.querySelector('.comu-bento-modal__close');
    if (closeBtn) closeBtn.setAttribute('aria-label', closeLabel);
    var content = dialog.querySelector('.comu-bento-modal__content');

    function close() {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }

    function open(card) {
      var body = card.querySelector('.bento-body');
      var payments = card.querySelector('.bento-payments');
      var heading = card.querySelector('.bento-heading');
      var icon = card.querySelector('.bento-icon');

      // 正文为空的卡不弹窗，避免弹出一个空框
      if (!body || !body.innerHTML.trim()) return;

      content.innerHTML = '';

      // 设计稿的弹窗里**不放图标**（home.js 里是 modalIcon.replaceChildren() 清空），
      // 所以默认关闭；需要展示时在后台打开开关。
      // ⚠️ 必须用 setAttribute('class')，不能写 .className：
      //    图标改走 comu-icon 之后是内联 <svg>，SVG 元素的 className 是只读的
      //    SVGAnimatedString，赋值会抛 TypeError，整个 open() 在 showModal() 之前就挂了
      //    —— 弹窗「点了没反应」就是这么来的。
      if (icon && root.dataset.modalIcon === '1') {
        var iconCopy = icon.cloneNode(true);
        iconCopy.setAttribute('class', 'comu-bento-modal__icon');
        content.appendChild(iconCopy);
      }

      if (heading) {
        var title = document.createElement('h2');
        title.className = 'comu-bento-modal__title';
        // 用 innerText 而不是 textContent：数字卡与支付卡的标题是几个块级 <span>
        // 拼出来的（12-Month + Warranty），textContent 会直接连成「12-MonthWarranty」。
        // innerText 按渲染结果取，块级之间带换行，压成空格后就是设计稿的写法。
        var raw = heading.innerText || heading.textContent || '';
        title.textContent = raw.replace(/\s+/g, ' ').trim();
        content.appendChild(title);
      }

      var bodyWrap = document.createElement('div');
      bodyWrap.className = 'comu-bento-modal__body';
      bodyWrap.innerHTML = body.innerHTML;
      content.appendChild(bodyWrap);

      if (payments) {
        var payWrap = document.createElement('div');
        payWrap.className = 'comu-bento-modal__payments';
        payWrap.innerHTML = payments.innerHTML;
        content.appendChild(payWrap);
      }

      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () { open(card); });
      card.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        open(card);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    // 点遮罩关闭：dialog 本身的点击区域即遮罩
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) close();
    });
  }


  /* ------------------------------------------------------------------
     商品入口卡「Learn more」快速查看弹窗
     ------------------------------------------------------------------
     内容不是本地拼的，是点击时 fetch 该商品自己的商品页、抽出购买区注入。
     Impact 自己做 quick buy 也是这么绕的（见 main-product-comu.liquid 末尾
     的 IMPLEMENTATION NOTE）：Shopify 不允许把任意 section 渲染到指定商品的
     上下文里，只能整页取回再截取。

     注入的是 Impact 的 <product-rerender>/<variant-picker>/<buy-buttons> 等
     自定义元素——它们由全局 theme.js 定义，插进文档时会自动升级，所以变体切换、
     加购、价格重算全都照常工作，这里一行都不用重写。
     ------------------------------------------------------------------ */
  function initProductQuickView(root) {
    if (root.dataset.comuQvBound === '1') return;
    root.dataset.comuQvBound = '1';

    var modal = root.querySelector('[data-comu-qv]');
    var body = root.querySelector('[data-comu-qv-body]');
    var panel = root.querySelector('[data-comu-qv-panel]');
    if (!modal || !body || !panel) return;

    var statusTpl = body.innerHTML;
    var cache = {};
    var lastTrigger = null;
    // lastTrigger 关闭时要清空（用于把焦点还回去），套餐注入需要一个
    // 在弹窗打开期间稳定可用的引用，所以单独存一份。
    var currentTrigger = null;
    var scrollY = 0;

    function lockScroll() {
      scrollY = window.pageYOffset || document.documentElement.scrollTop;
      document.documentElement.style.setProperty('--comu-qv-lock', scrollY + 'px');
      document.body.classList.add('comu-qv-open');
      document.body.style.top = '-' + scrollY + 'px';
    }

    function unlockScroll() {
      document.body.classList.remove('comu-qv-open');
      document.body.style.top = '';
      window.scrollTo(0, scrollY);
    }

    function close() {
      if (modal.hidden) return;
      modal.classList.remove('is-active');
      modal.hidden = true;
      // 清空是必须的：留着的话商品页那份 DOM 里的 id 会和下一次注入的撞，
      // 而且隐藏的 <video>/<model-viewer> 会继续占资源。
      body.innerHTML = statusTpl;
      unlockScroll();
      if (lastTrigger) { lastTrigger.focus(); lastTrigger = null; }
    }

    function extract(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      // 依次退让：Comu v2 购买区 → Impact 原生购买区 → 只要信息栏。
      var node = doc.querySelector('.product') ||
                 doc.querySelector('product-rerender') ||
                 doc.querySelector('.product-info');
      return node;
    }

    // 「只显示到加购按钮」：把加购所在的那一块之后的同级兄弟全部隐藏。
    //
    // 靠「位置」而不是「类名」来判断：加购下方那些块在 Impact 里是自动生成的
    // product-info__liquid，商家在后台加减内容时类名和数量都会变；而「加购之后」
    // 这个位置关系不会变。Action Pro 换成 v2 模板后，下方的 ComuCare 等模块
    // 同样会被切掉，不用再改这里。
    //
    // 用 hidden 属性而不是移除节点：加购表单可能依赖后面的隐藏 input，
    // 删掉会连带破坏表单。
    function trimBelowBuy() {
      if (root.dataset.qvTrim !== '1') return;
      var info = body.querySelector('.product-info');
      if (!info) return;
      var kids = Array.prototype.slice.call(info.children);
      var buyIndex = -1;
      for (var i = 0; i < kids.length; i++) {
        if (kids[i].querySelector('buy-buttons, button[name="add"], button[type="submit"]')) {
          buyIndex = i;
          break;
        }
      }
      if (buyIndex < 0) return;
      for (var j = buyIndex + 1; j < kids.length; j++) {
        kids[j].hidden = true;
        kids[j].setAttribute('aria-hidden', 'true');
      }
    }

    // 套餐插件（Kaching）在快速查看里的接入。
    //
    // 插件不是靠自定义元素工作的，而是扫描 `kaching-bundle` 这个**占位标签**
    // （源码里 selector 为 "kaching-bundle, kaching-bundle-deals"），
    // 再由它自己把档位 UI 渲染进去。它有一个 MutationObserver 会捕捉
    // 后插入的未初始化占位，但只有店铺开了 featureFlags.reinitialize_morphed_placeholders
    // 才会真的重新初始化——本店已开。这个开关是店铺级的，被关掉时本功能会静默失效。
    //
    // 注意 product-id 必须来自触发按钮（对应那张卡关联的商品），
    // 不能用页面级的 product——首页根本没有全局 product 对象。
    function injectBundles(trigger) {
      if (root.dataset.qvBundles !== '1') return;
      var productId = trigger && trigger.getAttribute('data-qv-product-id');
      if (!productId) return;                       // 卡片没关联商品就不插，避免留个空占位
      if (body.querySelector('kaching-bundle')) return;

      var info = body.querySelector('.product-info');
      if (!info) return;

      // 插在「加购所在的那一块」之前。不能插到它之后——那片区域会被
      // trimBelowBuy() 整体隐藏，套餐会跟着一起看不见。
      var kids = Array.prototype.slice.call(info.children);
      var buyBlock = null;
      for (var i = 0; i < kids.length; i++) {
        if (kids[i].querySelector('buy-buttons, button[name="add"], button[type="submit"]')) {
          buyBlock = kids[i];
          break;
        }
      }

      var placeholder = document.createElement('kaching-bundle');
      placeholder.setAttribute('product-id', productId);
      if (buyBlock) info.insertBefore(placeholder, buyBlock);
      else info.appendChild(placeholder);
    }

    function fill(url) {
      if (cache[url]) {
        body.innerHTML = '';
        body.appendChild(cache[url].cloneNode(true));
        trimBelowBuy();
        injectBundles(currentTrigger);
        body.scrollTop = 0;
        return;
      }
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) throw new Error('bad response');
          var node = extract(html);
          if (!node) throw new Error('no product node');
          cache[url] = node.cloneNode(true);
          body.innerHTML = '';
          body.appendChild(node);
          trimBelowBuy();
          injectBundles(currentTrigger);
          body.scrollTop = 0;
        })
        .catch(function () {
          // 抓不到就别把用户困在空弹窗里——给一条能走的路。
          body.innerHTML = '<div class="comu-qv__status"><span class="comu-qv__status-text">' +
            '<a href="' + url.replace(/"/g, '&quot;') + '">View full product page</a></span></div>';
        });
    }

    function open(trigger) {
      var url = trigger.getAttribute('data-qv-url');
      if (!url) return;
      lastTrigger = trigger;
      currentTrigger = trigger;
      body.innerHTML = statusTpl;
      modal.hidden = false;
      // 先落一帧再加 is-active，否则 opacity 过渡不触发。
      requestAnimationFrame(function () { modal.classList.add('is-active'); });
      lockScroll();
      var closeBtn = panel.querySelector('[data-comu-qv-close]');
      if (closeBtn) closeBtn.focus();
      fill(url);
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-comu-qv-open]'), function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        open(btn);
      });
    });

    var overlay = modal.querySelector('[data-comu-qv-overlay]');
    if (overlay) overlay.addEventListener('click', close);
    var closeBtn = modal.querySelector('[data-comu-qv-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  /* 视频弹窗播放（设计稿 openVideoModal + .global-video-modal）。
     用在只有一个视频的 Comu Video Tabs 实例上——设计稿里那种模块点播放键是
     弹出全屏播放器，不是就地播。多 Tab 的实例仍走内嵌播放。

     照抄 initKolCardsModule 的做法：<dialog> 由 JS 建、媒体从 <template> 克隆。
     好处有三——多实例不会撞 id、showModal() 白拿 Esc 关闭与焦点陷阱、
     关闭时把媒体整个清掉，iframe/video 不会留在后台继续出声。
     另外 <dialog> 打开后走浏览器的 top layer，天然压在所有内容之上，
     不需要参与 z-index 那套层级（见 comu-sections.css 头部的层级表）。 */
  function initVideoTabsModal(root) {
    if (!root || root.dataset.comuVtModalReady === 'true') return;

    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-comu-vt-modal-open]'));
    if (!triggers.length) return;
    root.dataset.comuVtModalReady = 'true';

    var dialog = document.createElement('dialog');
    dialog.className = 'comu-video-modal';
    dialog.innerHTML =
      '<div class="comu-video-modal__content">' +
      '<button type="button" class="comu-video-modal__close" aria-label="Close">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>' +
      '</button><div class="comu-video-modal__media"></div></div>';
    root.appendChild(dialog);

    var media = dialog.querySelector('.comu-video-modal__media');
    var content = dialog.querySelector('.comu-video-modal__content');

    function open(trigger) {
      var frame = trigger.closest('.comu-video-tabs__media');
      var tpl = frame ? frame.querySelector('[data-comu-vt-video]') : null;
      if (!tpl) return;

      media.appendChild(tpl.content.cloneNode(true));

      /* 竖版素材套 9:16，否则 contain 之后左右会剩两大块黑边。
         上传的视频要等元数据才知道宽高，先按横版展示再纠正。 */
      content.style.aspectRatio = '16 / 9';
      var video = media.querySelector('video');
      if (video) {
        var fit = function () {
          if (!video.videoWidth || !video.videoHeight) return;
          var portrait = video.videoHeight > video.videoWidth;
          content.style.aspectRatio = portrait ? '9 / 16' : '16 / 9';
          content.classList.toggle('comu-video-modal__content--portrait', portrait);
        };
        video.addEventListener('loadedmetadata', fit);
        fit();
      }

      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');

      /* 带声自动播放常被拦截，失败就把控制权交回给原生控件 */
      if (video && typeof video.play === 'function') {
        var played = video.play();
        if (played && typeof played.catch === 'function') played.catch(function () {});
      }
    }

    function close() {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      media.innerHTML = '';
      content.classList.remove('comu-video-modal__content--portrait');
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        open(trigger);
      });
    });

    /* 整个视频框都可点：设计稿的框带 cursor:pointer 与 hover 遮罩加深，
       只有右上角小圆钮能点会显得没反应 */
    Array.prototype.forEach.call(root.querySelectorAll('.comu-video-tabs__media--modal'), function (frame) {
      frame.addEventListener('click', function (event) {
        if (event.target.closest('[data-comu-vt-modal-open]')) return;
        var trigger = frame.querySelector('[data-comu-vt-modal-open]');
        if (trigger) open(trigger);
      });
    });

    dialog.querySelector('.comu-video-modal__close').addEventListener('click', close);
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) close();
    });
    /* Esc 走原生 cancel -> close，但部分内嵌浏览器不触发 close，两个都接管 */
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      close();
    });
    dialog.addEventListener('close', function () {
      media.innerHTML = '';
    });
  }

  function initAll(scope) {
    initGradientTitles(scope || document);
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-comu-hero-carousel]'), initHeroCarousel);
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-comu-kol-autofetch]'), initKolAutoFetch);
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-comu-floating-subscribe]'), initFloatingSubscribe);
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-comu-loop]'), initLoopCarousel);
    var container = scope || document;
    Array.prototype.forEach.call(container.querySelectorAll('[data-audience-module]'), initAudienceModule);
    Array.prototype.forEach.call(container.querySelectorAll('[data-ckm-module]'), initCkmModule);
    Array.prototype.forEach.call(container.querySelectorAll('[data-scenario-module]'), initScenarioModule);
    Array.prototype.forEach.call(container.querySelectorAll('[data-compliance-carousel]'), initComplianceCarousel);
    Array.prototype.forEach.call(container.querySelectorAll('[data-timeline-module]'), initTimelineModule);
    Array.prototype.forEach.call(container.querySelectorAll('[data-comu-media-module]'), initMediaQuoteModule);
    Array.prototype.forEach.call(container.querySelectorAll('[data-comu-video-tabs]'), initVideoTabsModule);
    Array.prototype.forEach.call(container.querySelectorAll('[data-comu-video-tabs]'), initVideoTabsModal);
    Array.prototype.forEach.call(container.querySelectorAll('[data-comu-video-toggle]'), initVideoPlayButton);
    Array.prototype.forEach.call(container.querySelectorAll('[data-comu-image-carousel]'), initImageCarouselModule);
    Array.prototype.forEach.call(container.querySelectorAll('[data-comu-review-cards]'), initReviewCardsModule);
    Array.prototype.forEach.call(container.querySelectorAll('[data-comu-bento]'), initBentoModule);
    Array.prototype.forEach.call(container.querySelectorAll('[data-comu-kol-cards]'), initKolCardsModule);
    Array.prototype.forEach.call(container.querySelectorAll('[data-comu-quick-nav]'), initQuickNavModule);
    Array.prototype.forEach.call(container.querySelectorAll('.comu-product-entry'), initProductQuickView);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // 主题编辑器中重新加载 section 时重新初始化
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
